import { useEffect, useMemo, useState } from "react"
import Icon from "../../../../../components/Icon"
import {
  Field,
  Container,
  Error,
  Label,
  CouponNumber,
  Button
} from './styles'
import { initialValues, schema } from "../../../../../constants/forms/apply-discount";
import couponIcon from "../../../../../assets/icons/coupon.svg"
import checkMark from "../../../../../assets/icons/checkmark-circle.svg"
import { ErrorMessage } from "../../../../../components/FormikForm/Field";
import { Center } from "../../../../../components/StyledComponents"
import { Formik } from "formik"
import Input from "../../../../../components/FormikForm/Input"
import Submit from "../../../../../components/FormikForm/Submit"
import { connect, useDispatch } from "react-redux"
import { existDiscount, resetExistDiscount } from "../../../../../store/actions/discount"
import { DiscountDto, Group } from "../../../../../types";
import { getUrlParamByName } from "../../../../../helpers/get-url-param";
import dateHelpers from "../../../../../helpers/dates-hanlder";

interface ComponentProps {
  group: Group
  existDiscountStates: {
    loading: boolean,
    success: boolean
    error: string | boolean
  }
  existDiscountData: DiscountDto
  coupon?: DiscountDto
  setCoupon: React.Dispatch<React.SetStateAction<DiscountDto | undefined>>
}

const Component = ({
  group,
  existDiscountStates,
  existDiscountData,
  coupon,
  setCoupon
}: ComponentProps) => {
  const dispatch = useDispatch()
  const [formSubmmited, setFormSubmmited] = useState<boolean>(false)
  const [showInput, setShowInput] = useState<boolean>(false)
  const [errors, setErrors] = useState<string>()

  const planId = useMemo(() => getUrlParamByName('planId'), [])
  const subscriptionId = useMemo(() => getUrlParamByName('subscriptionId'), []);

  const onSubmit = ({ values, actions }) => {
    setErrors('')
    dispatch(existDiscount(values))
  }

  useEffect(() => {
    const selectedPlan = existDiscountData?.plans.find(plan => plan.id === Number(planId));

    if (
      !existDiscountData?.show_in_page &&
      !!selectedPlan &&
      selectedPlan?.experts_group === group?.id &&
      !existDiscountData?.max_redemptions || (!!existDiscountData?.max_redemptions && existDiscountData?.redemptions < existDiscountData?.max_redemptions) &&
      existDiscountData?.status === 'active' &&
      !dateHelpers.isExpired(existDiscountData?.valid_till)
    ) {
      setCoupon(existDiscountData)
    }


    if (
      existDiscountStates?.success &&
      !!existDiscountData &&
      (
        existDiscountData?.status !== 'active' ||
        (!!existDiscountData?.max_redemptions && existDiscountData?.redemptions >= existDiscountData?.max_redemptions) ||
        dateHelpers.isExpired(existDiscountData?.valid_till)
      )
    ) {
      setErrors('El cupón ya no se encuentra disponible.')
    }

    if (
      existDiscountStates?.success &&
      !!existDiscountData &&
      (
        existDiscountData?.show_in_page ||
        !selectedPlan ||
        selectedPlan?.experts_group !== group?.id
      )) {
      setErrors('No es un cupón válido.')
    }

    if (existDiscountStates?.error) {
      setErrors('No es un cupón válido.')
    }
  }, [existDiscountData, existDiscountStates, group, planId, existDiscountData])

  if (subscriptionId) {
    return <></>
  }

  return !showInput ? (
    <>
      <Button
        options={{
          type: "link",
          skin: 'purple',
          size: 'lg'
        }}
        onClick={() => setShowInput(true)}
      >
        <Icon icon={couponIcon} size="24px" />
        Aplicar cupon de descuento
      </Button>

    </>
  ) : (
    <>
      {!coupon ? (
        <>
          <Center vertical="top" horizontal="left" gap={15}>
            <Formik
              initialValues={initialValues}
              onSubmit={(values, actions) => {
                if (onSubmit) onSubmit({ values, actions });
              }}
              validateOnChange={false}
              validateOnBlur={formSubmmited}
              validationSchema={schema}
              enableReinitialize
            >
              {({ handleSubmit, errors, values, touched, handleBlur, handleChange }) => {
                return (
                  <form
                    className="theme-form"
                    onSubmit={(event) => {
                      setFormSubmmited(true);
                      handleSubmit(event);
                    }}
                    id="add-discount-form"
                  >
                    <Input
                      name="coupon_id"
                      error={errors["coupon_id"]}
                      touched={touched["coupon_id"]}
                      value={values["coupon_id"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Cupón de descuento"
                      options={{
                        label: "",
                        marginBottom: 0
                      }}
                    />
                  </form>
                );
              }}
            </Formik>

            <Submit
              isSubmmiting={existDiscountStates.loading}
              options={{
                type: "filled",
                size: "lg",
                skin: "purple",
              }}
              form="add-discount-form"
              style={{ gap: 8, maxWidth: 118, margin: 0, height: 40, minWidth: 0 }}
            >
              <Icon icon={couponIcon} size="24px" color="white" />
              Aplicar
            </Submit>
          </Center>

          {errors && <>
            <div style={{ height: 10 }} />
            <ErrorMessage>{errors}</ErrorMessage>
          </>}
        </>
      ) : (
        <Center vertical="center" horizontal="left" gap={22}>
          <CouponNumber>
            {coupon?.coupon_id}
            <Icon icon={checkMark} size="19px" color="#12B47A" />
          </CouponNumber>

          <Button
            options={{
              type: "link",
              skin: 'purple',
              size: 'lg'
            }}
            onClick={() => {
              dispatch(resetExistDiscount())
              setCoupon(undefined)
            }}
          >
            Eliminar cupón
          </Button>
        </Center>
      )}
    </>
  )
}

const state = ({ discountStore, groupStore }) => {
  const { data: group } = groupStore?.group;
  const { data: existDiscountData, states: existDiscountStates } = discountStore?.existDiscount;


  return { existDiscountData, existDiscountStates, group };
};

export default connect(state)(Component);